import React from 'react'
import TableComptoir from '../../../Components/table/TableComptoir'

const Comptoir1 = () => {
  return <TableComptoir />
}

export default Comptoir1
